import API from '../config';

const base = `${API.BASE_DEV_HOST}/api`;
const userBaseUrl = `${base}/user`;

export const getUsers = () => `${base}/users`;
export const create = () => `${base}/profiles/`;
export const savePermissions = () => `${base}/users/permissions`;
export const userPermissions = (userId: number, firmId?: number) =>
  `${userBaseUrl}/${userId}/permissions/${firmId ?? ''}`;
export const firmUserPermissions = (firmId: number) => `${base}/users/firm_users/${firmId}`;
export const lowerUserPermissions = (userId: number) => `${userBaseUrl}/${userId}/lower-permissions`;
export const userProfileById = (userId: number) => `${base}/profiles/${userId}`;
export const updateUserProfile = (userId: number) => `${base}/profiles/${userId}`;
export const deleteUser = (userId: string) => `${userBaseUrl}/${userId}/delete`;
export const createBulkUsers = () => `${base}/users/create-bulk-users`;
export const deleteCompanyUserPermissions = (userId: number, companyId: number) =>
  `${base}/users/permissions/${userId}/${companyId}`;

export const getUserGenerationJobs = (activeOnly = true, processingType?: string) => {
  const params = new URLSearchParams();
  params.append('active_only', activeOnly.toString());
  if (processingType) params.append('processing_type', processingType);
  const queryString = params.toString();
  return `${base}/users/me/document-generation-jobs${queryString ? `?${queryString}` : ''}`;
};

export default getUsers;
